module.exports = __webpack_public_path__ + "img/icon-search-blue.d4cc5a67.svg";